import React from "react";
import styles from "./infoPanel.module.css";

export default function InfoPanel() {
  return (
    <div className={styles.infoPanel}>
      <div className={styles.content}>
        <h1>Arty Pifflator</h1>
        <p>
          I "needed" a way to quickly make the sort of arty nonsense you get
          describing contemporary artworks. There are quite a few available (see
          links below), but I needed something shorter so I made my own.
        </p>
        <p>
          Use the GENERATE buttons to create new piffle and edit the text as you
          wish using the text inputs.
        </p>

        <h2>Other Arty Nonsense Generators</h2>
        <ul>
          <li>
            <ExternalLink
              href="http://www.pixmaven.com/phrase_generator.html"
              text="The Instant Art Critique Phrase Generator"
            />
          </li>
          <li>
            <ExternalLink
              href="https://artybollocks.com/"
              text="Arty Bo***cks"
            />
          </li>
          <li>
            <ExternalLink
              href="http://500letters.org/form_15.php"
              text="      500 Letters"
            />
            . This one needs a bit more{" "}
            <ExternalLink
              href="https://hyperallergic.com/63686/the-best-artist-statement-generator-ive-seen-yet/"
              text="explanation"
            />
            .
          </li>
        </ul>

        <h2>Criticism of Arty Nonsense</h2>
        <ul>
          <li>
            <ExternalLink
              href="http://scottnaismith.com/art-speak-arty-nonsense-exposed/"
              text="OVER FLOWERY ARTISTS’ STATEMENTS"
            />
          </li>
          <li>
            <ExternalLink
              href="https://www.theguardian.com/artanddesign/2013/jan/27/users-guide-international-art-english"
              text=" A user's guide to artspeak"
            />
          </li>
        </ul>

        <h2>How to make one of your own</h2>
        <ul>
          <li>
            <ExternalLink
              href="https://www.youtube.com/watch?v=8Z9FRiW2Jlc"
              text="How to code this type of thing "
            />
            - called context-free grammar
          </li>
          <li>
            <ExternalLink
              href="https://observablehq.com/@dhowe/tut-rita-grammars"
              text="Rita"
            />
            : The library I used for the pifflator.
          </li>
          <li>
            <ExternalLink
              href="https://observablehq.com/@dhowe/tut-rita-grammars"
              text="Tutorial for using Rita"
            />
          </li>
          <li>
            <ExternalLink
              href="http://www.crystalcodepalace.com/traceryTut.html"
              text="Tracery"
            />
            : An example javascript library showing how to put things together
          </li>
        </ul>
      </div>
    </div>
  );
}

const ExternalLink = ({ href, text }) => (
  <a rel="noreferrer" target="_blank" href={href}>
    {text}
  </a>
);
